/* eslint-disable arrow-parens */
/* eslint-disable indent */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
import React from 'react'
import Button from 'react-bootstrap/Button'
import {
  Tab, TabList, TabPanel, Tabs,
} from 'react-tabs'
import * as H from 'history'
import { DashboardModel } from '../../../models/DashboardModel'
import CurrentYear from './Tabs/CurrentYear'
import History from './Tabs/History'
import { DashboardDetailModel } from '../../../models/DashboardDetailModel'
import { ISupportSpinner } from '../../../shared/Ajax'
import { Backdrop } from '../../../shared/Backdrop'
import { ApplicationController } from '../../../controllers/ApplicationController'
import { ClaimItem } from '../../../models/ClaimItem'
import { Loading, TextField } from '../../../shared/fields'
import { GlobalDataContext } from '../../../GlobalDataContext'

export interface Props {
  history: H.History
  // updateModel: (d: DashboardModel) => void
  startNewAppTextHtml: string
}

export interface State {
  searchTxt: string
  model: DashboardModel
  loading: boolean
}

export default class MyDashboard extends React.Component<Props, State> implements ISupportSpinner {
  static contextType = GlobalDataContext
  context!: React.ContextType<typeof GlobalDataContext>
  ajax: ApplicationController
  constructor(props: Props) {
    super(props)

    this.ajax = new ApplicationController()
    this.state = {
      searchTxt: '',
      model: null,
      loading: false,
    }
  }

  async componentDidMount() {
    this.ajax.getCurrentList(
      this,
      (d) => {
        this.setState({ model: d })
        // this.props.updateModel(d) // Call the updateModel function passed as a prop
      },
    )
  }

  // eslint-disable-next-line class-methods-use-this
  hasSubmittedApplication = (dashboardDetail: DashboardDetailModel[], financialYear: string): boolean => {
    if (!dashboardDetail) return true
    let hasSubmittedApplication = false
    dashboardDetail.filter((f) => f.round === financialYear).forEach((d: DashboardDetailModel) => {
      if (d.applicationStatus.toLowerCase() !== 'draft' && d.applicationStatus.toLowerCase() !== 'withdrawn') {
        hasSubmittedApplication = true
      }
    })
    return hasSubmittedApplication
  }

  handleSearchText = (val: string) => {
    this.setState({ searchTxt: val })
  }

  handleApplicationClick = (id: string): void => {
    const { history } = this.props
    history.push(`/dashboard-reform/${id}/summary`)
  }

  validateNewApplication = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    const { model, model: { dashboardDetailModels, isConsultant } } = this.state

    if (!isConsultant) {
      const inProgressApplicationStatus = ['Submitted',
        'Assessment in progress',
        'Pending grant agreement',
        'Grant agreement in draft',
        'Grant agreement issued',
        'Grant agreement pending changes from applicant',
        'Grant agreement accepted by applicant',
        'Grant agreement pending changes by Austrade',
      ]

      const inProgressApplications = dashboardDetailModels.filter((f) => inProgressApplicationStatus.findIndex((el) => el.toLowerCase() === f.applicationStatus.toLocaleLowerCase()) > -1)

      if (inProgressApplications.length > 0) {
        alert(`WARNING: Our system has identified that you have an existing application/pending grant agreement under a previous EMDG round. Please note that EMDG applicants can only enter one EMDG Grant Agreement at a time. If you accept and execute one Grant Agreement, we will deem the other pending Grant Agreement to be withdrawn.

Please note, this does not affect any ongoing appeals you may have lodged regarding an earlier grant agreement.`)
      }

      this.ajax.isActiveGrantAgreement(this, model.abn, (hasActiveGrantAgreement) => {
        if (hasActiveGrantAgreement) {
          alert('You have an executed grant agreement and Grantees cannot apply for a new EMDG grant while there is more than one year remaining until the Activity Completion Date. Please refer to Section C in your grant agreement.')
        } else {
          this.openApplication()
        }
      })
    }
  }

  sortClaims = (a: ClaimItem, b: ClaimItem): number => {
    const yearDif = b.year - a.year

    if (yearDif === 0) {
      if (a.account < b.account) return -1
      return 1
    }

    return yearDif
  }

  openApplication = () => {
    this.ajax.create(this, (d) => {
      const { history } = this.props
      if (d) history.push(`/reform/${d}`)
    })
  }

  newClaim = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    this.props.history.push('/dashboard-forms')
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  render() {
    const {
      searchTxt, model, loading,
    } = this.state

    if (!model || loading) return <Loading />

    const { history } = this.props

    const tierDataCtx = this.context
      console.log('tierSettingsArr:', tierDataCtx.tierSettingsArr)

    // Get the current date
    //  const now = new Date() NO, use server-date from AppService!

    // Check if there is at least one object with openingDate <= now and (closingDate > now or closingDate is null)
    const currentDate = new Date()
    const hasOpenTier = tierDataCtx.tierSettingsArr?.some(item => {
        const openingDate = item.openingDateUTC ? new Date(item.openingDateUTC) : null
        const closingDate = item.closingDateUTC ? new Date(item.closingDateUTC) : null

        // If openingDate is not null and it's in the past
        const isOpen = openingDate ? openingDate <= currentDate : false

        // If closingDate is not null and it's in the future, or if it's null
        const isNotClosed = closingDate ? closingDate > currentDate : true

        return isOpen && isNotClosed
    })

    const disableSubmit = !hasOpenTier || !model?.financialYearName
                          || (!model?.isConsultant && this.hasSubmittedApplication(model?.dashboardDetailModels, model?.financialYearName))

    const isSearchbarDisabled = model?.dashboardDetailModels?.length === 0
    const startNewApplicationFn = model.isConsultant ? this.openApplication : this.validateNewApplication

    return (
      <>
        <div style={{ marginTop: 30 }}>
          <h4>Applications</h4>
          <div dangerouslySetInnerHTML={{ __html: this.props.startNewAppTextHtml }} />

          <p style={{ marginBottom: 10 }}>
              <span>
                Grants under the EMDG Reimbursement scheme can be viewed&nbsp;
              </span>
              <span onClick={this.newClaim} className="hyperlink" role="none">here</span>
                .
              <br />
          </p>

          <Button
            className="emdg-btn"
            id="btnStartNewApplication"
            onClick={disableSubmit ? null : startNewApplicationFn}
            disabled={!!disableSubmit}
          >
            Start new application
          </Button>
        </div>

        {/* <h2>My Applications</h2> */}
        <div className="emdg-callout mt-5 mb-4">
          <div className="row">
            <div className="col-md-7">
              <p className="mb-2">Search</p>
              <TextField asYouType label="" id="txtSearch" block value={searchTxt} onChange={(e) => this.handleSearchText(e)} disabled={isSearchbarDisabled} />
            </div>
            {/*
            <div style={{ textAlign: 'center' }} className="col-md-1 align-self-center">
              <h3 className="mt-3">or</h3>
            </div>
            <div className="col-md-3">
              <p className="mb-2">&nbsp;</p>
              <Button
                className="emdg-btn"
                id="btnStartApplication"
                onClick={disableSubmit ? null : startNewApplicationFn}
                disabled={!!disableSubmit}
              >
                Start new application
              </Button>
            </div>
             */}
          </div>
        </div>
        <Tabs>
          <TabList>
            <Tab>Current</Tab>
            <Tab>History</Tab>
          </TabList>

          <TabPanel>
            <CurrentYear loading={loading} model={model} handleApplicationClick={this.handleApplicationClick} searchTxt={searchTxt} />
          </TabPanel>
          <TabPanel>
            <History searchTxt={searchTxt} history={history} />
          </TabPanel>
        </Tabs>
        <Backdrop on={loading} />
      </>
    )
  }
}
